var React = require('react');

function IconSocialTwitter (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#242424","fillOpacity":".3","key":0}),React.createElement("path",{"d":"M13.554 23.636c6.792 0 10.51-5.632 10.51-10.509 0-.158 0-.317-.008-.475a7.525 7.525 0 001.844-1.916 7.486 7.486 0 01-2.125.583 3.716 3.716 0 001.628-2.045 7.348 7.348 0 01-2.348.893A3.686 3.686 0 0020.36 9a3.698 3.698 0 00-3.695 3.695c0 .288.036.57.093.843a10.488 10.488 0 01-7.613-3.86 3.703 3.703 0 001.145 4.934 3.736 3.736 0 01-1.67-.462v.05a3.701 3.701 0 002.96 3.623c-.31.087-.634.13-.973.13-.237 0-.468-.021-.691-.065a3.693 3.693 0 003.45 2.565 7.408 7.408 0 01-4.588 1.584 7.11 7.11 0 01-.879-.05 10.506 10.506 0 005.654 1.65z","fill":"#fff","key":1})]);
}

IconSocialTwitter.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = IconSocialTwitter;

IconSocialTwitter.default = IconSocialTwitter;
